import Settings from '../api/settings';
import { notify } from './message';
import { push } from 'react-router-redux/lib/actions';

const settings = new Settings();

export const  SETTINGS_SAVE = 'SETTINGS_SAVE';
export const  SETTINGS_SAVE_FAIL = 'SETTINGS_SAVE_FAIL';
export const  SETTINGS_SAVE_SUCCESS = 'SETTINGS_SAVE_SUCCESS';
export const  SETTINGS_FETCH = 'SETTINGS_FETCH';
export const  SETTINGS_FETCH_FAIL = 'SETTINGS_FETCH_FAIL';
export const  SETTINGS_FETCH_SUCCESS = 'SETTINGS_FETCH_SUCCESS';

export function fetch() {
  return dispatch => {
    return Promise.resolve(dispatch({type: SETTINGS_FETCH}))
      .then(() => settings.fetch())
      .then(
        () => dispatch({
            type: SETTINGS_FETCH_SUCCESS,
            settings
          }),

        response => dispatch({
          type: SETTINGS_FETCH_FAIL,
          response
        })
      );
  };
}

export function save(data) {
  Object.assign(settings, data);

  return dispatch => {
    return Promise.resolve(dispatch({type: SETTINGS_SAVE}))
      .then(() => settings.save())
      .then(
        () => Promise.resolve(dispatch({
          type: SETTINGS_SAVE_SUCCESS,
          settings
        }))
          .then(() => dispatch(notify('Changes have been saved')))
          .then(() => dispatch(push('/'))),

        response => dispatch({
          type: SETTINGS_SAVE_FAIL,
          response
        })
      );
  };
}



// WEBPACK FOOTER //
// ./src/actions/settings.js